import { FC } from 'react';
import { SmallLogo } from '@dynamika-shared/ui/icons';

const SUPPORT_EMAIL = 'support@ia-grp.com';

export const MaintenancePage: FC = () => {
  return (
    <div
      className='flex h-full w-full flex-col items-center justify-between'
      data-testid='maintenance-page'
    >
      <SmallLogo className='m-6 min-h-[92px] min-w-[92px]' />
      <div className='-mt-10 flex h-full w-full flex-col items-center justify-center'>
        <h2 className='text-[3.6rem] font-semibold uppercase leading-[4rem] tracking-normal'>
          Site is under maintenance
        </h2>
        <p className='mb-6 mt-2.5 w-[50%] whitespace-pre-line text-center text-1624'>
          We are performing scheduled maintenance to improve your experience.
          {'\n'}Please come back in a little while.
        </p>
      </div>
      <div className='border-brightGray text-spanishGray text-1420 flex w-full justify-center gap-1 border-[1px] py-[16px]'>
        <span>For more information, contact our support team:</span>
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          target='_blank'
          rel='noreferrer'
          className='text-vividTangelo'
        >
          {SUPPORT_EMAIL}
        </a>
      </div>
    </div>
  );
};
